import React from "react";

// Kleiner Abschnitts-Titel mit Eyebrow, zentriert oder linksbündig
export default function SectionTitle({ eyebrow, title, description, align = "center", light = false }) {
  const alignClass = align === "center" ? "text-center mx-auto" : "text-left";
  return (
    <div className={`max-w-2xl ${alignClass} mb-12`}>
      {eyebrow && (
        <span className="inline-block text-accent text-sm font-600 uppercase tracking-[0.25em] mb-3">
          {eyebrow}
        </span>
      )}
      <h2
        className={`font-serif text-3xl md:text-5xl font-600 leading-tight ${
          light ? "text-white" : "text-foreground"
        }`}
      >
        {title}
      </h2>
      {description && (
        <p
          className={`mt-4 text-lg font-300 leading-relaxed ${
            light ? "text-white/80" : "text-muted-foreground"
          }`}
        >
          {description}
        </p>
      )}
    </div>
  );
}
